import React from 'react';
import ObiLoading from '../common/ObiLoading';

import { ListItemText,
  ListItemIcon,
  ListItem,
  List,
  IconButton,
  Collapse,
  Hidden,
  Button,
  Drawer,
  Divider,
  AppBar,
  Toolbar,
  Grid,
  Box,
  Icon,
  Typography } from '@mui/material';

import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MenuIcon from '@mui/icons-material/Menu';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AssessmentIcon from '@mui/icons-material/Assessment';
import HelpIcon from '@mui/icons-material/Help';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

import { makeStyles, useTheme } from '@mui/styles';

import { connect } from 'react-redux';
import { withRouter } from "react-router";
import { Link } from 'react-router-dom';

import ObiLogo from '../common/obigraphics/ObiLogo';

import EnvBanner from '../common/EnvBanner';

import Brightness5Icon from '@mui/icons-material/Brightness5';
import Brightness3Icon from '@mui/icons-material/Brightness3';

import {
  logoutTools,
  generalSwitchTheme
} from '../../actions';

const { REACT_APP_VERSION } = process.env;

const toolsNav = {
  "dashboard": {
    name: 'Dashboard',
    icon: DashboardIcon,
    url: '/tools/',
  },
  "loginAs": {
    name: 'Access Account',
    icon: AccountCircleIcon,
    permissionName: 'PERMIT_LOGIN_AS',
    url: '/tools/login-account',
  },
  "hsasales": {
    name: 'Sales Report',
    icon: AssessmentIcon,
    permissionName: 'PERMIT_SALES_REPORT',
    url: '/tools/sales',
  },
  "manageads": {
    name: 'Manage Ads',
    icon: AssessmentIcon,
    permissionName: 'PERMIT_MANAGE_ADS',
    url: '/tools/ads',
  },
  "manageupdates": {
    name: 'Manage Updates',
    icon: AssessmentIcon,
    permissionName: 'PERMIT_DEVELOPER',
    url: '/tools/updates',
  },
  "resendWelcome": {
    name: 'Resend Welcome',
    icon: EmailIcon,
    url: undefined,
    external: false,
    permissionName: 'PERMIT_AUDIT',
    innerList: {
      "sendERWelcome": {
        name: 'Send ER Welcome',
        icon: EmailIcon,
        permissionName: 'PERMIT_SEND_RECEIPTS',
        url: '/tools/send-welcome/er',
      },
      "sendEEWelcome": {
        name: 'Send EE Welcome',
        icon: EmailIcon,
        permissionName: 'PERMIT_SEND_RECEIPTS',
        url: '/tools/send-welcome/ee',
      },
      "sendAgentWelcome": {
        name: 'Send Agent Welcome',
        icon: EmailIcon,
        permissionName: 'PERMIT_SEND_RECEIPTS',
        url: '/tools/send-welcome/agent',
      },
    }
  },
  "sendReceipt": {
    name: 'Send Receipt',
    icon: EmailIcon,
    permissionName: 'PERMIT_SEND_RECEIPTS',
    url: '/tools/send-receipt',
  },
  "sendPartnerReceipt": {
    name: 'Send Partner Receipt',
    icon: EmailIcon,
    permissionName: 'PERMIT_SEND_RECEIPTS',
    url: '/tools/send-partner-receipt',
  },
  "claimaudit": {
    name: 'Audit Claim',
    icon: AssessmentIcon,
    permissionName: 'PERMIT_AUDIT',
    url: '/tools/audit/claims',
  },
  "auditpad": {
    name: 'Audit Pad',
    icon: AssessmentIcon,
    url: undefined,
    external: false,
    permissionName: 'PERMIT_AUDIT',
    innerList: {
      "padauditemployee":{
        name: 'Audit Employee PAD',
        icon: AssessmentIcon,
        permissionName: 'PERMIT_AUDIT',
        url: '/tools/pad-audit/employee'
      },
      "padauditemployer":{
        name: 'Audit Employer PAD',
        icon: AssessmentIcon,
        permissionName: 'PERMIT_AUDIT',
        url: '/tools/pad-audit/employer'
      },
      "padauditagent":{
        name: 'Audit Agent PAD',
        icon: AssessmentIcon,
        permissionName: 'PERMIT_AUDIT',
        url: '/tools/pad-audit/agent'
      },
    }
  },
  "recalemployeelimit": {
    name: 'Recalc Employee Limit',
    icon: EmailIcon,
    permissionName: 'PERMIT_AUDIT',
    url: '/tools/recal-employee-limit',
  },
  "apitester": {
    name: 'Api Tester',
    icon: AssessmentIcon,
    permissionName: 'PERMIT_DEVELOPER',
    url: '/tools/api-tester',
  },
  "apiroutes": {
    name: 'Api Routes',
    icon: AssessmentIcon,
    permissionName: 'PERMIT_DEVELOPER',
    url: '/tools/api-routes',
  },
}

const drawerWidth = 280;

const useStyles = makeStyles((theme) => ({
  root: {
    // display: 'flex',
  },
  footer: {
    height: '100px'
  },
  drawer: {
    [theme.breakpoints.up('md')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
    zIndex: 5,

  },
  appBar: {
    zIndex: theme.zIndex.drawer - 1,
    backgroundColor: theme.palette.appBar.main,
    color: theme.palette.appBar.contrastText,
    [theme.breakpoints.up('md')]: {
      paddingLeft: `${drawerWidth}px`
    },
  },
  appProfile:{
    textDecoration: 'none',
    textTransform: 'capitalize',
    userSelect: 'none',
    color: theme.palette.primary.main,
  },
  appTitle:{
    color: theme.palette.appBar.contrastText,
    [theme.breakpoints.up('md')]: {
      paddingLeft: `15px`
    },
  },
  appLogo:{
    textDecoration: 'none',
    padding: theme.spacing(1),
    width: '100px'
  },
  appVersion:{
    padding: theme.spacing(2),
    color: theme.palette.common.white,
    textAlign:'right'
  },
  menuButton: {
    marginLeft: theme.spacing(1),
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: theme.palette.drawer.main,
    color: theme.palette.drawer.contrastText
  },
  drawerId:{
    padding: theme.spacing(1),
    marginTop: theme.spacing(1),
    borderRadius: '5px',
    backgroundColor: theme.palette.drawerId.main,
    color: theme.palette.drawerId.contrastText
  },
  drawerNav:{
    color: theme.palette.drawerNav.contrastText,
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: theme.palette.drawerNav.hover,
    }
  },
  drawerNavIcon:{
    color: theme.palette.drawerNav.contrastText
  },
  nested: {
    paddingLeft: theme.spacing(4),
    color: theme.palette.drawerNav.contrastText,
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: theme.palette.drawerNav.main,
    }
  },
  disablednested:{
    paddingLeft: theme.spacing(4),
    backgroundColor: theme.palette.ltgrey.main,
    '&:hover': {
      backgroundColor: theme.palette.ltgrey.main,
    }
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      marginLeft: drawerWidth
    },
  },
}));

function hasPermission(permission_name, permissions) {
  return permissions['ALL_ACCESS'] === 'Y' || permissions[permission_name] === 'Y';
}


function updateTheme(props){
  props.generalSwitchTheme();
}

function renderNavElement(navElement, props, classEle, classIcon, endIcon){
  if(navElement.willRender && !navElement.willRender(props)){
    return false;
  }

  if(navElement.permissionName && !hasPermission(navElement.permissionName, props.permissions)){
    return false;
  }

  let disabled = false;
  if(navElement.isDisabled){
    if(typeof navElement.isDisabled == 'function'){
      disabled = navElement.isDisabled(props);
    }else{
      disabled = (navElement.isDisabled);
    }
  }

  return <ListItem key={navElement.name+'navEle'} 
    className={classEle}
    button
    {...(navElement.url)? {to: navElement.url, component: Link}: {}} 
    {...(disabled)? {disabled: disabled}: {}}
    {...(navElement.onClick)? {onClick: navElement.onClick, component: Button}: {}}
     >
    <ListItemIcon><Icon className={classIcon} component={navElement.icon} /></ListItemIcon>
    <ListItemText primary={navElement.name} />
    {endIcon}
  </ListItem>
}

function renderList(navElement, props, classes, handleMenuExpand, expanded, renderFlat=false){
  if(!navElement){
    return false;
  }
  if(!navElement.innerList || Object.values(navElement.innerList).length < 1){
    return renderNavElement(navElement, props, classes.drawerNav, classes.drawerNavIcon);
  }
  if(renderFlat){
    return <div>
      {Object.values(navElement.innerList).map((innerNavElement) => {
        return renderNavElement(innerNavElement, props, classes.nested, classes.drawerNavIcon);
        })}
    </div>
  }
  return (
    <div>
      <ListItem key={navElement.name} className={classes.drawerNav} button onClick={() => handleMenuExpand(navElement.name)}>
        <ListItemIcon><Icon className={classes.drawerNavIcon} component={navElement.icon} /></ListItemIcon>
        <ListItemText primary={navElement.name} />
        {expanded[navElement.name] ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={expanded[navElement.name]} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {Object.values(navElement.innerList).map((innerNavElement) => {
            return renderNavElement(innerNavElement, props, classes.nested, classes.drawerNavIcon);
            })}
        </List>
      </Collapse>
    </div>
  );
}

function WrapperTools(props) {

  const { window } = props;
  const classes = useStyles();
  const theme = useTheme();
  const [expanded, setExpanded] = React.useState(false);
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleMenuExpand = (id) => {
    setExpanded((prevState => ({...prevState, [id]: !prevState[id]})));
  }

  const drawer = (
    <div>
      <Grid container justifyContent="flex-start" alignItems="center" >
        <Grid item xs={12}>
          <Box p={2}>
            <Grid container justifyContent="center" alignItems="center">
              <Grid item xs={6}>
                <ObiLogo width="100%" fill="#fff"/>
              </Grid>
            </Grid>
            <Grid container justifyContent="space-between" alignItems="center" className={classes.drawerId}>
              <PersonIcon />
              <Typography>{props.user}</Typography>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      <Divider />
      <List>
        {Object.values(toolsNav).map( (navElement) => {
          return renderList(navElement, props, classes, handleMenuExpand, expanded, false);
        })}
      </List>
      <Divider />
      <List>
        <ListItem className={classes.drawerNav} button onClick={ () => props.logoutTools() }>
          <ListItemIcon><ExitToAppIcon className={classes.drawerNavIcon} /></ListItemIcon>
          <ListItemText primary={'Logout'} />
        </ListItem>
      </List>
      <Divider />
      <List>
        <ListItem key={'Logout'} className={classes.drawerNav} button onClick={()=>updateTheme(props)} >
          <ListItemIcon><Icon className={classes.drawerNavIcon} component={(props.chosenTheme == 'dark')? Brightness5Icon: Brightness3Icon} /></ListItemIcon>
          <ListItemText primary={(props.chosenTheme == 'dark')? 'Enable Light Mode': 'Enable Dark Mode'} />
        </ListItem>
      </List>
      <Typography className={classes.appVersion} variant="caption" display="block" align="right">app v{REACT_APP_VERSION}<br/>Copyright © {new Date().getFullYear()} Olympia Benefits Inc.<br/>All Rights Reserved</Typography>
    </div>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <div className={classes.root}>
      <AppBar position="sticky" className={classes.appBar}>
        <EnvBanner />
        <Grid container justifyContent="flex-start" alignItems="center">
          <Grid item >
            <Toolbar disableGutters>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                className={classes.menuButton}
              >
                <MenuIcon />
              </IconButton>
            </Toolbar>
          </Grid>

          <Hidden mdUp>
            <Grid item >
              <Grid container direction='row' justifyContent="center" alignItems="center">
                <Grid item >
                  <ObiLogo height={50} fill="#0068a8"/>
                </Grid>
              </Grid>
            </Grid>
          </Hidden>

          <Hidden smDown>
            <Grid item xs zeroMinWidth>
              <Typography className={classes.appTitle} noWrap>{props.title}</Typography>
            </Grid>
          </Hidden>
        </Grid>
      </AppBar>
      <nav className={classes.drawer} aria-label="mailbox folders">
        <Hidden mdUp implementation="js">
          <Drawer
            container={container}
            variant="temporary"
            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden smDown implementation="js">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawer}
          </Drawer>
        </Hidden>
      </nav>
      <main className={classes.content}>
        {(props.inSuspense)? <ObiLoading /> : props.children}
        <div className={classes.footer} />
      </main>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.tools.username,
    permissions: state.tools.permissions,
    chosenTheme: state.general.chosenTheme
  };
};

export default connect(mapStateToProps, {
  logoutTools,
  generalSwitchTheme
})(withRouter(WrapperTools));
